import { LOADER } from "resources/actionTypes";

export function onLoaderTrigger(payload){
    return {
     type:LOADER.LOADER_TRIGGER,
     payload:payload
    }
}